import { FuelDivider, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { DS_TOKENS } from 'constants/styled.contants';
import React, { PropsWithChildren, ReactElement } from 'react';

interface IGenericInfoItem {
  title: string;
  displayDivider?: boolean;
}

const GenericInfoItem = ({ title, displayDivider, children }: PropsWithChildren<IGenericInfoItem>): ReactElement => (
  <FuelFlex defaultProps={{ flexDirection: 'column' }} testId={`${title.toLowerCase().replace(' ', '-')}`}>
    <FuelFlex
      defaultProps={{
        justifyContent: 'space-between',
        customPadding: `${DS_TOKENS.spacing.km4} 0`,
      }}
      smProps={{ flexDirection: 'column', gap: 'km2' }}
    >
      <FuelTypography size="body-md" color="neutral-default" weight="medium">
        {title}
      </FuelTypography>
      <FuelFlex
        defaultProps={{ flexDirection: 'column', gap: 'km2', maxWidth: '60%', alignItems: 'flex-end' }}
        smProps={{ flexDirection: 'column', maxWidth: 'unset', alignItems: 'flex-start' }}
      >
        {children}
      </FuelFlex>
    </FuelFlex>
    {displayDivider && <FuelDivider data-testid="generic-info-item-divider" />}
  </FuelFlex>
);

GenericInfoItem.defaultProps = {
  displayDivider: true,
};

export default GenericInfoItem;
